module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "400px"
    },
    model: {
      value: (_vm.shown),
      callback: function($$v) {
        _vm.shown = $$v
      },
      expression: "shown"
    }
  }, [_c('v-card', [(_vm.fatalError) ? _c('v-card-text', [_c('v-alert', {
    attrs: {
      "error": "",
      "icon": "warning",
      "value": "true"
    }
  }, [_vm._v(_vm._s(_vm.fatalError))])], 1) : [_c('v-card-title', {
    staticClass: "headline"
  }, [(_vm.recording) ? _c('span', [_vm._v(_vm._s(_vm.$t('player.title')))]) : _c('span', [(!_vm.privateKey) ? _c('span', [_vm._v(_vm._s(_vm.$t('player.titlePrivateKeySettings')))]) : _vm._e(), _vm._v(" "), (_vm.privateKey && !_vm.decoding) ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('player.titlePrivateKeyPass')))]) : _vm._e()])]), _vm._v(" "), (_vm.recording && _vm.shown) ? _c('v-card-text', {
    staticClass: "text-xs-center"
  }, [_c('audio', {
    ref: "player",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "timeupdate": _vm.timeUpdated,
      "canplay": function($event) {
        _vm.canPlay = true
      },
      "pause": function($event) {
        _vm.paused = true
      },
      "play": function($event) {
        _vm.paused = false
      }
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.recording,
      "type": _vm.audioType
    },
    on: {
      "error": _vm.playError
    }
  })]), _vm._v(" "), _c('loadable', {
    attrs: {
      "loading": !_vm.canPlay
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paused),
      expression: "paused"
    }],
    staticClass: "ma-0",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.play
    }
  }, [_c('v-icon', [_vm._v("play_arrow")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.paused),
      expression: "!paused"
    }],
    staticClass: "ma-0",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.pause
    }
  }, [_c('v-icon', [_vm._v("pause")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.stop
    }
  }, [_c('v-icon', [_vm._v("stop")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "xs4": ""
    }
  }, [_c('v-slider', {
    staticClass: "py-0",
    attrs: {
      "prepend-icon": "volume_up",
      "hide-details": "",
      "min": 0,
      "max": 100
    },
    model: {
      value: (_vm.volume),
      callback: function($$v) {
        _vm.volume = $$v
      },
      expression: "volume"
    }
  })], 1)], 1), _vm._v(" "), _c('v-slider', {
    staticClass: "px-3 py-2",
    attrs: {
      "hide-details": "",
      "value": _vm.currentTime,
      "min": 0,
      "max": 100
    },
    on: {
      "input": _vm.changeTime
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.recording && _vm.record && _vm.record.encrypted) ? _c('v-card-text', [_c('loadable', {
    attrs: {
      "loading": _vm.decoding,
      "description": _vm.$t('player.decryptingInProgress')
    }
  }, [(!_vm.privateKey) ? [_c('div', {
    on: {
      "drop": _vm.drop
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('player.privateKeyPrompt')))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "multi-line": "",
      "label": _vm.$t('player.privateKey'),
      "error-messages": _vm.privateKeyErrors,
      "hide-details": ""
    },
    model: {
      value: (_vm.privateKeyForm),
      callback: function($$v) {
        _vm.privateKeyForm = $$v
      },
      expression: "privateKeyForm"
    }
  }), _vm._v(" "), _c('input', {
    ref: "file",
    staticClass: "my-2",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.fileChanged
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": _vm.$t('player.saveLocally')
    },
    model: {
      value: (_vm.saveKey),
      callback: function($$v) {
        _vm.saveKey = $$v
      },
      expression: "saveKey"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.applyKey
    }
  }, [_vm._v(_vm._s(_vm.$t('player.continue')))])], 1)], 1)] : [_c('p', [_vm._v(_vm._s(_vm.$t('player.passPrompt')))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "password",
      "label": _vm.$t('player.passphrase'),
      "hide-details": "",
      "error-messages": _vm.privateKeyPassErrors
    },
    model: {
      value: (_vm.privateKeyPass),
      callback: function($$v) {
        _vm.privateKeyPass = $$v
      },
      expression: "privateKeyPass"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": _vm.$t('player.saveTemporary')
    },
    model: {
      value: (_vm.saveKeyPass),
      callback: function($$v) {
        _vm.saveKeyPass = $$v
      },
      expression: "saveKeyPass"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearKey($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('player.forgetKey')))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.applyPass
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("lock_open")]), _vm._v(" " + _vm._s(_vm.$t('player.decrypt')))], 1)], 1)]], 2)], 1) : _vm._e()], _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.recording && _vm.record && _vm.record.encrypted),
      expression: "recording && record && record.encrypted"
    }],
    staticClass: "red--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearKey($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('player.forgetKey')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.recording && !_vm.fatalError),
      expression: "recording && !fatalError"
    }],
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.download($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('player.download')))]), _vm._v(" "), _c('v-btn', {
    staticClass: "darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.shown = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('close')))])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e408f38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Player.vue
// module id = 1089
// module chunks = 1